import {
  Button,
  Flex,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useMemo } from "react";
import { usePagination, useRowSelect, useTable } from "react-table";
import { CheckboxForTable } from "./CheckboxForTable.js";
import "./table.css";

export const CustomizedTable = ({ column, data, onSelectRow }) => {
  const columns = useMemo(() => column, [column]);
  const rowData = useMemo(() => data, [data]);

  const tableInstance = useTable(
    {
      columns: columns,
      data: rowData,
    },
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => {
        return [
          {
            id: "selection",
            Header: ({ getToggleAllRowsSelectedProps }) => (
              <CheckboxForTable
                {...getToggleAllRowsSelectedProps()}
              ></CheckboxForTable>
            ),
            Cell: ({ row }) => (
              <CheckboxForTable
                {...row.getToggleRowSelectedProps()}
              ></CheckboxForTable>
            ),
          },
          ...columns,
        ];
      });
    }
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state,
    gotoPage,
    pageCount,
    selectedFlatRows,
    prepareRow,
  } = tableInstance;

  const { pageIndex } = state;
  let rowIds = selectedFlatRows.map((data) => data.original.id);
  useEffect(() => {
    onSelectRow(rowIds);
  }, [rowIds, onSelectRow]);

  return (
    <Flex direction="column" h="100%" w="100%">
      <Table {...getTableProps} id="customers">
        <Thead>
          {headerGroups.map((headerGroup) => (
            <Tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <Th
                  fontSize="24px"
                  height="50px"
                  fontWeight="bold"
                  {...column.getHeaderProps()}
                >
                  {column.render("Header")}
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()}>
                {row.cells.map((cell) => {
                  return (
                    <Td fontSize="18px" {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
      <Flex direction="column">
        <Flex p={5} justify="center">
          <Button
            mx="2"
            onClick={() => gotoPage(0)}
            disabled={!canPreviousPage}
          >
            {"<<"}
          </Button>

          <Button
            mx="2"
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            fontWeight="bold"
          >
            {"मागे"}
          </Button>
          <Flex align="center" mx="2">
            <Text fontWeight="bold" fontSize="20px">
              <strong>
                {pageOptions.length} {" पैकी पृष्ठ "}
                {pageIndex + 1}
              </strong>{" "}
            </Text>
          </Flex>
          <Button
            mx="2"
            onClick={() => nextPage()}
            disabled={!canNextPage}
            fontWeight="bold"
          >
            {"पुढे"}
          </Button>
          <Button
            mx="2"
            onClick={() => gotoPage(pageCount - 1)}
            disabled={!canNextPage}
          >
            {">>"}
          </Button>
        </Flex>
        <Flex mb={2} justify="center" align="center">
          <Text mx={2} fontWeight="bold" fontSize="20px">
            {"पृष्ठावर जा"}
          </Text>
          <Input
            w="100px"
            type="number"
            defaultValue={pageIndex + 1}
            onChange={(e) => {
              const pageNumber = e.target.value
                ? Number(e.target.value) - 1
                : 0;
              gotoPage(pageNumber);
            }}
          ></Input>
        </Flex>
      </Flex>
    </Flex>
  );
};
